import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { InstagramStrip } from "@/components/InstagramStrip";
import { useLang, track } from "@/context/LanguageContext";
import { BSPORT } from "@/data/config";

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function StickyMobileCTA() {
  const { t } = useLang();
  return (
    <div className="fixed bottom-0 left-0 z-40 w-full border-t border-onyx/10 bg-petal/95 px-4 py-3 backdrop-blur-sm sm:hidden" data-testid="sticky-cta">
      <div className="grid grid-cols-2 gap-3">
        <a
          href={BSPORT.INTRO_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track("intro_offer_click", { source: "sticky" })}
          className="label bg-onyx py-3 text-center text-petal"
          data-testid="sticky-intro"
        >
          {t.common.threeForFiftyNine}
        </a>
        <Link
          to="/schedule"
          onClick={() => track("book_class_click", { source: "sticky" })}
          className="label border border-onyx py-3 text-center text-onyx"
          data-testid="sticky-book"
        >
          {t.nav.book}
        </Link>
      </div>
    </div>
  );
}

export function Layout({ children }) {
  useLenis();
  const { pathname } = useLocation();
  if (pathname.startsWith("/newsletter") || pathname.startsWith("/intro/") || pathname === "/signature") {
    return (
      <div className="App">
        <ScrollToTop />
        <main>{children}</main>
      </div>
    );
  }
  return (
    <div className="App min-h-screen bg-petal">
      <ScrollToTop />
      <Navbar />
      <main className="pb-16 sm:pb-0">{children}</main>
      <InstagramStrip />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
